<button
  *ngIf="showScrollToTop"
  mat-fab
  color="primary"
  type="button"
  class="scroll-up-button"
  aria-label="Voltar ao topo"
  matTooltip="Voltar ao topo"
  (click)="scrollToTop($event)"
>
  <mat-icon>keyboard_arrow_up</mat-icon>
</button>
<button
  *ngIf="showScrollToBottom"
  mat-fab
  color="primary"
  type="button"
  class="scroll-down-button"
  aria-label="Ir ao fim"
  matTooltip="Ir ao fim"
  (click)="scrollToBottom($event)"
>
  <mat-icon>keyboard_arrow_down</mat-icon>
</button>
